import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { DateTimeFormatters } from '@showclix-projects/sc-intl';
import { ISOStringToDate } from 'helpers/time';
import Translation from "../../shared/Translation";

class TicketsGoOnSale extends Component<TicketsGoOnSaleProps> {
    getOnsaleTime = () => {
        let onsale = <Translation>{"checkout__tickets_not_currently_on_sale"}</Translation>;
        if (!this.props.isPaused && this.props.uiConfig.listings && this.props.uiConfig.listings.displayOnsaleTime !== 'undefined') {
            if (this.props.uiConfig.listings.displayOnsaleTime === true && this.props.onsaleDate !== null) {
                const { fullDateShort } = DateTimeFormatters;

                let onsaleDate = new Date(this.props.onsaleDate);
                if (onsaleDate.toString() == "Invalid Date") {

                    onsaleDate = ISOStringToDate(this.props.onsaleDate);

                }

                if (onsaleDate >= new Date()) {
                    const localeOnsale = fullDateShort(this.props.locale, onsaleDate);
                    onsale = <Translation interpolation={{ localeOnsale:localeOnsale }}>{"checkout__tickets_go_on_sale"}</Translation>;
                }
            }
        }

        return onsale;
    };

    render() {
        if (this.props.isOnsale || this.props.inviteCouponApplied) {
            return null;
        }

        return(
            <address>
                <span className="event-details__location-name">{this.getOnsaleTime()}</span><br />
            </address>
        );
    }
}

const mapStateToProps = (state, props) => {
    const venue = state.venue.venues ? Object.values(state.venue.venues)[0] : null;
    return {
        locale: state.intl.locale,
        isOnsale: state.event.events ? Object.values(state.event.events)[0].event.isOnsale : false,
        isPaused: state.event.events ? Object.values(state.event.events)[0].event.isPaused : false,
        uiConfig: state.ui.uiConfig,
        onsaleDate: state.event.events ? Object.values(state.event.events)[0].event.onsaleDate : "",
        inviteCouponApplied: state.couponTag.appliedTaggableInvitationCode || state.reservation.hasInviteCoupon,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

TicketsGoOnSale.propTypes = {
    locale: PropTypes.string.isRequired,
    isOnsale: PropTypes.bool.isRequired,
    onsaleDate: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketsGoOnSale)
